import { CustomElement, resolve } from 'aurelia';
import { AnalyticsAdminService } from '../../services';
import template from './analytics-admin-panel.html';
import './analytics-admin-panel.css';

// Admin-only modal that shows the signup funnel: how many browser sessions visited, how many
// were prompted, how many started the Auth0 redirect, and how many finished registering, over a
// selectable trailing window. Opened from the admin menu; all state and the load call live in
// AnalyticsAdminService. Read-only: it is a measurement view, not an editor.
export class AnalyticsAdminPanelElement {
  readonly analytics: AnalyticsAdminService = resolve(AnalyticsAdminService);
}

export const AnalyticsAdminPanel = CustomElement.define({
  name: 'analytics-admin-panel',
  template
}, AnalyticsAdminPanelElement);
